/**
 * Stripe's description field includes an "ending in" suffix after the card type.
 */
export const removeEndingIn = (name: string) => {
  return name.replaceAll('ending in', '').trim();
};
